"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobPostingSchema = void 0;
const zod_1 = require("zod");
const candidate_1 = require("../candidate");
exports.JobPostingSchema = zod_1.z.object({
    id: zod_1.z.string(),
    companyId: zod_1.z.string(),
    districtId: zod_1.z.string(),
    industryId: zod_1.z.string(),
    occupationId: zod_1.z.string(),
    postedById: zod_1.z.string(),
    isActive: zod_1.z.boolean(),
    accessInfo: zod_1.z.string().nullish(),
    applicationInstructions: zod_1.z.string().nullish(),
    bonusPolicy: zod_1.z.string().nullish(),
    contactInfo: zod_1.z.string().nullish(),
    coverImage: zod_1.z.string().nullish(),
    description: zod_1.z.string(),
    employeeBenefits: zod_1.z.string().nullish(),
    expiredAt: zod_1.z.string().datetime(),
    leavePolicy: zod_1.z.string().nullish(),
    locationDetail: zod_1.z.string().nullish(),
    memo: zod_1.z.string().nullish(),
    postedAt: zod_1.z.string().datetime(),
    probationPeriod: zod_1.z.string().nullish(),
    qualification: zod_1.z.string().nullish(),
    salaryExpectation: zod_1.z.string(),
    salaryIncreasePolicy: zod_1.z.string().nullish(),
    specialDescription: zod_1.z.string().nullish(),
    specialImage: zod_1.z.string().nullish(),
    specialTopic: zod_1.z.string().nullish(),
    summary: zod_1.z.string(),
    title: zod_1.z.string(),
    workHours: zod_1.z.string().nullish(),
    estimatedSalaryMax: zod_1.z.number().int().nullish(),
    estimatedSalaryMin: zod_1.z.number().int().nullish(),
    isDraft: zod_1.z.boolean(),
    companySearchKeyword: zod_1.z.array(zod_1.z.string()),
    images: zod_1.z.array(zod_1.z.string()),
    salaryExamples: zod_1.z.array(zod_1.z.string()),
    testimonials: zod_1.z.object({
        quote: zod_1.z.string(),
        role: zod_1.z.string().nullish(),
        tenure: zod_1.z.string().nullish(),
        title: zod_1.z.string(),
    }).array().nullish(),
    applicationSteps: zod_1.z.any().nullish(),
    educationLevel: candidate_1.EducationLevelEnum,
    employmentType: candidate_1.EmploymentTypeEnum,
});
